<template >
<div v-if="asset">
  <a :href="thumbnailUrl" target="_blank">
    <img :src="asset.thumbnail" :srcset="srcset" :width="width" height="auto" @error="imgUrlDefault"/>
  </a>
</div>
</template>

<script>
export default {
  props: {
    asset: Object,
    width: Number,
    url: String
  },
  computed: {
    thumbnailUrl() {
      return this.url || this.asset.url;
    },
    srcset() {
      const { asset } = this;
      let data = [`${asset.thumbnail} 1x`];
      if (asset.thumbnail_2x) {
        data.push(`${asset.thumbnail_2x} 2x`);
      }
      return data.join(', ');
    }
  },
  methods: {
    imgUrlDefault: function (e) {
       e.target.style.display = 'none';
    }
  }
};
</script>